


























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Public } from '@/http/api_Public'; 
import 'swiper/dist/css/swiper.css'
import $ from 'jquery';
// import 'animate.css';
@Component({ 
    components: {}, 
})
export default class productCharacteristic extends Vue {
  
    public $refs!: {
        mySwiper:HTMLFormElement
    };

    activeName=1;

    timerInterval = null;

    swiperOption={
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        // //循环
        loop:true,
        //每张播放时长3秒，自动播放
        autoplay:{
            delay:3000,
            disableOnInteraction: false,
        },
      
    }
    
  
    async mounted() {
      
    }
    async created() {
    }

    // handleClick(val){
        
    //     this.activeName=val;
     
    //     this.$refs.mySwiper.swiper.slideTo(val, 1000, false);
        
    //     $('#tab_bar').css('transform',`translateX(${(val-1)*193}px)`)
    // }

    // slideChange(){
    //     this.activeName = this.$refs.mySwiper.swiper.activeIndex==7?1:this.$refs.mySwiper.swiper.activeIndex;
    //     // console.log('this.activeName',this.activeName);
    //     if(this.activeName==0){
    //         $('#tab_bar').css('transform',`translateX(${(6-1)*193}px)`)
    //         return
    //     }
    //     $('#tab_bar').css('transform',`translateX(${(this.activeName-1)*193}px)`)
    // }
  
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/productCharacteristic.vue